import React from "react";
import Layout from "./Layout";
import Plan from "../Plan/Plan";
import Details from "../Details/Details";

const Layouts = () => {
  return (
    <>
      <img src="layout.webp" className="imgg" alt="terrace-image" />
      <Layout />
      <img src="grid.webp" className="imgg" alt="terrace-image" />
      <Plan />
      <Details />
    </>
  );
};

export default Layouts;
